// extracted by mini-css-extract-plugin
export default {"table-cell":"TableSkeleton_table-cell__SRAIZ","tr":"TableSkeleton_tr__C0ooA","table-row":"TableSkeleton_table-row__KV7TL"};